<template>
	<div
		class="group w-full cursor-pointer rounded-md border-2 bg-neutral-50 transition duration-300 hover:border-sky-600"
		data-type="plan-selection"
		:class="[isSelected ? 'radio-highlight' : '']"
		@click="selectThis"
	>
		<div class="flex items-center rounded-md p-3">
			<div class="w-full p-2">
				<p
					v-if="subheadline"
					class="text-lg font-medium"
					:class="isSelected ? 'text-white' : 'text-blue-400'"
				>
					{{ subheadline }}
					<sup v-if="footnoteTitle">{{ footnoteTitle }}</sup>
				</p>
				<p
					v-if="headline"
					class="pb-1 font-medium"
					:class="isSelected ? 'text-white' : 'text-gray-700'"
				>
					{{ headline }}
					<sup v-if="footnoteTitle && !subheadline">
						{{ footnoteTitle }}
					</sup>
				</p>
				<p
					v-if="description"
					class="font-normal leading-tight"
					:class="isSelected ? 'text-white' : 'text-gray-600'"
				>
					{{ description }}
				</p>
			</div>
			<IconTick
				v-if="isSelected"
				class="h-[26px] w-[26px] text-sky-600"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import IconTick from '@/assets/svg/common/ico-tick-outline.svg'

interface Props {
	subheadline?: string
	headline: string
	description: string
	footnoteTitle?: string
	isSelected?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
	(event: 'onSelected'): void
}>()

const selectThis = () => {
	emit('onSelected')
}
</script>

<style scoped>
.radio-highlight {
	@apply border-2 border-sky-600 bg-sky-600 !important;
	margin: 0px;
}
</style>
